import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import TarjetaHorizontal from "../components/TarjetaHorizontal";

import personalizado from '../images/icon_personalizado.png';
import estrategico from '../images/icon_bishop.png';
import confiable from '../images/icon_confiable.png';
import oportuno from '../images/icon_oportuno.png';

const NuestroCompromiso = () => {
    return (
        <section className="section nuestro-compromiso" id="nuestroservicio">
            <Container className="vertical">
                <Row>
                    <Col lg={12} className="mb-3">
                        <h1 className="heading1">Nuestro Servicio</h1>
                    </Col>
                </Row>
                <Row className="justify-content-center">
                    <Col lg={12} md={12} sm={12} xs={12} className="mb-2">
                        <TarjetaHorizontal
                            title="Personalizado"
                            CustomIcon={personalizado}
                            text="Soluciones adaptadas al contexto del cliente." />
                    </Col>
                </Row>
                <Row>
                    <Col lg={6} md={6} sm={12} xs={12} className="mb-2">
                        <TarjetaHorizontal
                            title="Estratégico"
                            CustomIcon={estrategico}
                            secondary = {true}
                            text="Visión a futuro para anticipar cambios y tendencias." />
                    </Col>
                    <Col lg={6} md={6} sm={12} xs={12} className="mb-2">
                        <TarjetaHorizontal
                            title="Confiable"
                            CustomIcon={confiable}
                            secondary = {true}
                            text="Trabajo íntegro con información objetiva y precisa." />
                    </Col>
                </Row>
                <Row>
                    <Col lg={12} md={12} sm={12} xs={12} className="mb-2">
                        <TarjetaHorizontal
                            title="Oportuno"
                            CustomIcon={oportuno}
                            text="Respuestas rápidas para decisiones efectivas." />
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default NuestroCompromiso;